import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PWAInstallPromptComponent } from './pwa-install-prompt.component';
import { TranslateModule } from '@ngx-translate/core';
import { DownloadPWADialogModule } from '@go-modules/components/dialogs/download-pwa';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		DownloadPWADialogModule
	],
	declarations: [
		PWAInstallPromptComponent
	],
	exports: [
		PWAInstallPromptComponent
	]
})
export class PWAInstallPromptModule {}
